require('./accessibility');

import helpers from './helpers';

import 'alpine-magic-helpers'
import 'alpinejs';
import Spitting from 'splitting';


// Used to wrap inline text in spans for use in animations & transitions
Spitting();

window.helpers = helpers;

window.AlpineComponents = {
    // Larger than average Alpine components will be attached to this
    // object from within the site's template. DO NOT DELETE PLEASE!
}

// Requires a package
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

window.addEventListener("load", function() {
    // Scroll behavior polyfill. Only runs in browsers that do not support smooth scroll behavior. It turns css smooth scroll into JS click events
    // if ('scrollBehavior' in document.documentElement.style && window.__forceSmoothScrollPolyfill__ !== true) {
    scrollBehaviorSmooth();
});

function scrollBehaviorSmooth() {
    let heroScrollTrigger = document.getElementById("heroScrollTrigger");

    if (!heroScrollTrigger) {
        return;
    }

    let anchorQuery = document.querySelector("a[name='mainscrollanchor']");

    heroScrollTrigger.addEventListener("click", function() {
        anchorQuery.scrollIntoView({ behavior: 'smooth' });
    });
}